import React from "react";
import { Link } from "react-router-dom";

interface PageTitleProps {
  pageTitle: string;
  pagesub?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ pageTitle, pagesub }) => {
  return (
    <section
      className="breadcrumb"
      style={{
        background: "linear-gradient(180deg, #f0faf6 0%, #eef6ff 60%, #f8fafc 100%)",
      }}
    >
      <div className="container">
        <div className="breadcrumb__content">
          <ul className="breadcrumb__list clearfix list-unstyled">
            <li className="breadcrumb-item">
              <Link to="/home" style={{ color: "rgba(15,32,64,0.5)" }}>Home</Link>
            </li>
            {pagesub && (
              <li className="breadcrumb-item" style={{ color: "rgba(15,32,64,0.5)" }}>
                {pagesub}
              </li>
            )}
          </ul>
          {pageTitle && (
            <h2 className="breadcrumb__title" style={{ color: "#0f2040" }}>
              {pageTitle}
            </h2>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageTitle;
